import { Component, OnInit, ViewChild } from '@angular/core';
import { DocumentoNegociableService } from '../../../services/documento-negociable/documento-negociable.service';
import { CavaliService } from 'app/services/Cavali/Cavali.service';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { RiesgoService } from '../../../services/riesgo/riesgo.service';
import { Observable } from 'rxjs/Rx';
import { startWith, map } from 'rxjs/operators';
import { EmpresasService } from '../../../services/empresas/empresas.service';
import { FormControl,FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { FiltrosDocumentosNegociables } from '../../../models/FiltrosDocumentosNegociables';
import Swal from "sweetalert2";
import { LoginService } from 'app/services/login/login.service';
import { environment } from 'environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../models/messages';
import * as moment from 'moment';
import { DatePipe } from "@angular/common";
import { MomentDateAdapter } from "@angular/material-moment-adapter";

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY"
  }
};
declare var $: any;
@Component({
  selector: 'app-listado-acfin',
  templateUrl: './listado-acfin.component.html',
  styleUrls: ['./listado-acfin.component.css'],
  providers: [MessagesTitles,MessagesGeneral,MessagesDates,
    DatePipe,
  
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class ListadoAcfinComponent implements OnInit {
  
  isRiesgo: boolean = false;
  selectRegistro: boolean = false;
  listadoProcesosTemp:any;
  user : any;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  // usuarios:any[]=[];
  pageSizeOptions = [15,20,30,50,100,200];
  loading:boolean;
  displayedColumns: string[] = 
            ['checked','codigo','fecha_envio','fecha_corte','usuario','estado','link1'];
  dataSource :any; 
   DTOFiltrosDocNeg :FiltrosDocumentosNegociables = new FiltrosDocumentosNegociables();
   
  readonly ROLE_ADMIN: number = environment.ROLE_ADMIN_ID;
  readonly ROLE_RIESGO: number = environment.ROLE_RIESGO_ID;
  readonly ROLE_OPERACIONES: number = environment.ROLE_OPERACIONES_ID; // Rol Riesgo desde bd SecurityDBDev
  constructor( private negociablesService:DocumentoNegociableService,
               private riesgo: RiesgoService,  
               private empresasService: EmpresasService, 
               private cavaliService : CavaliService,
               private router:Router,
               private loginService:LoginService,
               private datePipe:DatePipe) {
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    
    //this.DTOFiltrosDocNeg.FechaIni = this.datePipe.transform(moment(),'yyyy-MM-dd');
    this.DTOFiltrosDocNeg.FechaIni = this.datePipe.transform(moment().add(-30, 'days'),'yyyy-MM-dd');
    
    this.DTOFiltrosDocNeg.Estado = '';
    this.cargarListadoCompleto(); 
    this.userHasValidRole([this.ROLE_ADMIN, this.ROLE_RIESGO, this.ROLE_OPERACIONES]);
   }
  ngOnInit() {
     
   
  }
  userHasValidRole(id_roles: number[]) {
    if(!id_roles.includes(this.user.id_roles)){
      this.displayedColumns = 
      ['fecha_envio','fecha_corte','estado','link1'];
    };
  }
  CerrarVenta(){
   
    this.selectRegistro = false;
    this.cargarListadoCompleto(); 

   
 } 
  agregarNuevo() {
      this.selectRegistro = true;
  }
  
  cargarListadoCompleto(){
    this.loading = true;
    let data = { 
      "Estado":this.DTOFiltrosDocNeg.Estado,
      "CodOperacion":'',
      "FechaIni":this.DTOFiltrosDocNeg.FechaIni
    }
    this.riesgo.obtenerProcesosACFIN(data).subscribe(
      res => {
        this.listadoProcesosTemp = res;

        //this.listadoProcesosTemp = this.listadoProcesosTemp.filter(elem => elem.Estado_Financiamiento_Fondo == "Activo")
        this.dataSource = new MatTableDataSource( this.listadoProcesosTemp);
        
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.loading = false;
      }
    )
  
  }

  filtradoListado(){
    this.loading = true;
    
    let data = { 
      "Estado":this.DTOFiltrosDocNeg.Estado,
      "CodOperacion":this.DTOFiltrosDocNeg.CodOperacion,
      "FechaIni":this.datePipe.transform(this.DTOFiltrosDocNeg.FechaIni,"yyyy-MM-dd")
    }
 
    this.riesgo.obtenerProcesosACFIN(data)
    .subscribe( resp => { 
        this.listadoProcesosTemp = resp;

        //this.listadoProcesosTemp = this.listadoProcesosTemp.filter(elem => elem.Estado_Financiamiento_Fondo == "Activo")
        this.dataSource = new MatTableDataSource( this.listadoProcesosTemp);
        
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.loading = false;

    })

  }


  showNotification(type,from,align,message){
    
    //const type = ['','info','success','warning','danger']; => tipo de notificacion
    //from = [Top,bottom,etc] => orientacion vertical
    //align = center, left, right => orientacion horizontal
  
    $.notify({
        icon: "notifications",
        message: message
    },{
        type: type,
        timer: 4000,
        placement: {
            from: from,
            align: align
        },
        template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
            '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          '</div>' +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }

  enviarACFIN(idProceso){
    this.loading = true;
    let data = {  
      "idProceso":idProceso, 
    }
    Swal.fire({
      title: 'Enviar ACFIN',
      text: '¿Deseas enviar a ACFIN las interfaces?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Si',
      cancelButtonColor: '#d33',
      cancelButtonText: 'No',
      heightAuto: false
    }).then((result) => {
      if (result.value) {
          this.riesgo.enviarProcesoACFIN(data,idProceso).subscribe(
            res => {
              let rpt = res;
              this.showNotification('success','top','right','Envío a ACFIN. '+ rpt);
              this.loading = false;
            }, err => { 
              this.showNotification('danger','top','right','Error al intentar enviar las interfaces.');
            }
          )
          
          Swal.fire({
            title: 'Satisfactorio!',
            text: 'Las interfaces se han enviado correctamente.',
            type: 'success',
            heightAuto: false
          }).then(()=> {
            this.cargarListadoCompleto(); 
          })
      }
    })
    
  }
}
